<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="600px"
    top="8vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    custom-class="house-form-dialog"
  >
    <el-form
      ref="houseForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
      label-position="right"
      size="medium"
    >
      <!-- 区域 -->
      <el-form-item label="区域：" prop="address">
            <el-select
              v-model="formData.address"
              placeholder="请选择区域"
              style="width: 100%"
              clearable
            >
              <el-option label="南区" value="南区" />
              <el-option label="北区" value="北区" />
            </el-select>
          </el-form-item>
      
      <!-- 楼栋号 -->
      <el-form-item label="楼栋号：" prop="building">
        <el-input
          v-model="formData.building"
          placeholder="请输入楼栋号"
          clearable
          :maxlength="20"
        />
      </el-form-item>
      
      <!-- 房间号 -->
      <el-form-item label="房间号：" prop="roomNum">
        <el-input
          v-model="formData.roomNum"
          placeholder="请输入房间号"
          clearable
          :maxlength="20"
        />
      </el-form-item>
      
      <!-- 状态 -->
      <el-form-item label="状态：" prop="status">
        <el-select
          v-model="formData.status"
          placeholder="请选择状态"
          style="width: 100%"
        >
          <el-option label="未出租" value="未出租" />
          <el-option label="已出租" value="已出租" />
        </el-select>
      </el-form-item>
      
      <!-- 面积 -->
      <el-form-item label="面积(㎡)：" prop="roomSquare">
        <el-input
          v-model="formData.roomSquare"
          placeholder="请输入面积"
          clearable
          type="number"
          :min="0"
          :step="0.01"
        >
          <template slot="append">㎡</template>
        </el-input>
      </el-form-item>
      <!-- 水表号 -->
      <el-form-item label="水表号：" prop="waterMeterNumber">
        <el-input
          v-model="formData.waterMeterNumber"
          placeholder="请输入水表号"
          clearable
          :maxlength="20"
        />
      </el-form-item>
      <!-- 电表号 -->
      <el-form-item label="电表号：" prop="meterNumber">
        <el-input
          v-model="formData.meterNumber"
          placeholder="请输入电表号"
          clearable
          :maxlength="20"
        />
      </el-form-item>
      <!-- 燃气表号 -->
      <el-form-item label="燃气表号：" prop="gasMeterNumber">
        <el-input
          v-model="formData.gasMeterNumber"
          placeholder="请输入燃气表号"
          clearable
          :maxlength="20"
        />
      </el-form-item>
      
      <!-- 价格 -->
      <el-form-item label="价格(元)：" prop="price">
        <el-input
          v-model="formData.price"
          placeholder="请输入价格"
          clearable
          type="number"
          :min="0"
        >
          <template slot="prepend">
            <i class="el-icon-money"></i>
          </template>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <!-- 详情 -->
      <el-form-item label="详情：" prop="detail">
        <el-input
          v-model="formData.detail"
          type="textarea"
          placeholder="请输入房屋详情"
          :rows="4"
          :maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="medium">
        取消
      </el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit" 
        size="medium"
        :loading="submitting"
      >
        确认{{ isEdit ? '修改' : '添加' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'HouseFormDialog',
  
  props: {
    // 是否显示对话框
    visible: {
      type: Boolean,
      default: false
    },
    
    // 表单数据
    formData: {
      type: Object,
      default: () => ({})
    },
    
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    // 价格验证规则
    const validatePrice = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入价格'))
      } else if (isNaN(Number(value))) {
        callback(new Error('价格必须是数字'))
      } else if (Number(value) < 0) {
        callback(new Error('价格不能为负数'))
      } else {
        callback()
      }
    }
    
    // 面积验证规则
    const validateArea = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入面积'))
      } else if (isNaN(Number(value))) {
        callback(new Error('面积必须是数字'))
      } else if (Number(value) <= 0) {
        callback(new Error('面积必须大于0'))
      } else {
        callback()
      }
    }
    
    return {
      // 提交状态
      submitting: false,
      
      // 表单验证规则
      rules: {
        address: [
          { required: true, message: '请输入区域', trigger: 'blur' },
          { max: 50, message: '区域不能超过50个字符', trigger: 'blur' }
        ],
        building: [
          { required: true, message: '请输入楼栋号', trigger: 'blur' },
          { max: 20, message: '楼栋号不能超过20个字符', trigger: 'blur' }
        ],
        roomNum: [
          { required: true, message: '请输入房间号', trigger: 'blur' },
          { max: 20, message: '房间号不能超过20个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        roomSquare: [
          { required: true, validator: validateArea, trigger: 'blur' }
        ],
        price: [
          { required: true, validator: validatePrice, trigger: 'blur' }
        ],
        detail: [
          { max: 500, message: '详情不能超过500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  
  computed: {
    // 对话框标题
    dialogTitle() {
      return this.isEdit ? '修改房屋信息' : '添加房屋信息'
    }
  },
  
  watch: {
    // 监听对话框显示状态
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.houseForm) {
            this.$refs.houseForm.clearValidate()
          }
        })
      }
    },
    
    // 监听表单数据变化
    formData: {
      handler(newVal) {
        // 处理数字字段
        if (newVal.roomSquare) {
          newVal.roomSquare = Number(newVal.roomSquare)
        }
        if (newVal.price) {
          newVal.price = Number(newVal.price)
        }
      },
      deep: true,
      immediate: true
    }
  },
  
  methods: {
    /**
     * 处理提交
     */
    handleSubmit() {
      this.$refs.houseForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            // 深拷贝表单数据，避免修改原数据
            const submitData = {
              ...this.formData
            }
            
            // 确保数字字段是数字类型
            if (submitData.roomSquare) {
              submitData.roomSquare = Number(submitData.roomSquare)
            }
            if (submitData.price) {
              submitData.price = Number(submitData.price)
            }
            
            // 触发保存事件
            this.$emit('save', submitData)
          } catch (error) {
            console.error('表单提交失败:', error)
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.warning('请正确填写表单信息')
          return false
        }
      })
    },
    
    /**
     * 处理关闭
     */
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* 对话框表单样式 */
.house-form-dialog .el-form-item {
  margin-bottom: 20px;
}

.house-form-dialog .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.house-form-dialog .el-input__inner,
.house-form-dialog .el-textarea__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.house-form-dialog .el-input__inner:focus,
.house-form-dialog .el-textarea__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.house-form-dialog .el-input-group__prepend {
  background-color: #f5f7fa;
  border-color: #dcdfe6;
}

.house-form-dialog .el-input-group__append {
  background-color: #f5f7fa;
  border-color: #dcdfe6;
  color: #606266;
}

.house-form-dialog .el-select {
  width: 100%;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button {
  min-width: 80px;
  margin-left: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .house-form-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
  }
}
</style>

<style>
/* 全局样式覆盖 */
.house-form-dialog .el-dialog__header {
  padding: 20px 20px 10px;
  border-bottom: 1px solid #ebeef5;
}

.house-form-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.house-form-dialog .el-dialog__title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #409EFF;
  border-radius: 2px;
  margin-right: 8px;
}

.house-form-dialog .el-dialog__body {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.house-form-dialog .el-dialog__footer {
  padding: 15px 20px;
}

/* 动画效果 */
.house-form-dialog .el-dialog {
  animation: dialog-fade-in 0.3s ease;
}

@keyframes dialog-fade-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 滚动条样式 */
.house-form-dialog .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.house-form-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.house-form-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.house-form-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>